$(document).ready(function () {
  document.querySelectorAll('.info-card-gallery').forEach((container) => {
    const triggerModal = (clickedSlide) => {
      clickedSlide.classList.add('active');
      const modal = document.getElementById(clickedSlide.dataset.modalId);
      if (modal) {
        modal.classList.add('active');
        const closeHandler = (event) => {
          if (
            !event.target.closest('.info-card-gallery-modal__close') &&
            event.target.closest('.info-card-gallery-modal__card')
          ) return;
          modal.classList.remove('active');
          clickedSlide.classList.remove('active');
          modal.removeEventListener('click', closeHandler);
        };
        modal.addEventListener('click', closeHandler);
      }
    };

    container.addEventListener('click', function (event) {
      const clickedSlide = event.target.closest('.info-card-gallery-item');
      if (!clickedSlide) return;
      triggerModal(clickedSlide);
    });

    const swiperEl = container.querySelector('.info-card-gallery-items.swiper-container');
    if (swiperEl) {
      new Swiper(swiperEl, {
        slidesPerView: 1.05,
        spaceBetween: 12,
        pagination: {
          el: container.querySelector('.swiper-pagination'),
          clickable: true,
        },
        scrollbar: {
          el: container.querySelector('.swiper-scrollbar'),
          draggable: true,
        },
        breakpoints: {
          480: {
            slidesPerView: 1.05,
            spaceBetween: 12,
          },
          768: {
            slidesPerView: 2.1,
            spaceBetween: 12,
            enabled: true,
          },
          990: {
            enabled: false,
          },
          0: {
            enabled: true,
          }
        }
      });
    }
  });
});